function helperLog (type, msg) {
  return (console[type] || console.log)(msg)
}

module.exports = helperLog



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/helperLog.js
// module id = 1169
// module chunks = 75